import { render, staticRenderFns } from "./ProjectActivity.vue?vue&type=template&id=62b3f86d&scoped=true"
import script from "./ProjectActivity.vue?vue&type=script&lang=ts"
export * from "./ProjectActivity.vue?vue&type=script&lang=ts"
import style0 from "./ProjectActivity.vue?vue&type=style&index=0&id=62b3f86d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b3f86d",
  null
  
)

export default component.exports